import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { PortInfo } from '@libs/trip-planner-interfaces';

import type {
  AddFlightsModalInitialRoute,
  AddFligthsModalRoute,
} from '../addFlightsModal.model';

const { t } = i18n.global;

export const yourPositionLabel = t('modals.addFlights.yourPostion');

export function mapToAddFlightsModalRoute(
  initialRoute: AddFlightsModalInitialRoute
): AddFligthsModalRoute {
  return {
    from: initialRoute.from?.displayText || yourPositionLabel,
    fromAirport: getEmptyAirport(),
    to: initialRoute.to?.displayText || yourPositionLabel,
    toAirport: getEmptyAirport(),
    isEnabled: initialRoute.isEnabled,
    ingredientId: initialRoute.ingredientId,
    isLast: initialRoute.isLast,
    isDirect: false,
    nightStayLabel:
      initialRoute.numberOfNights &&
      !initialRoute.isLast &&
      initialRoute.to?.displayText
        ? getNightStayLabel(
            initialRoute.numberOfNights,
            initialRoute.to?.displayText
          )
        : undefined,
  };
}

function getEmptyAirport(): PortInfo {
  return {
    code: undefined,
    name: undefined,
    label: undefined,
  };
}

function getNightStayLabel(
  numberOfNights: number,
  destination: string
): string {
  return `${numberOfNights} ${t(
    'planner.nights',
    numberOfNights
  ).toLocaleLowerCase()} ${t('planner.in')} ${destination}`;
}
